import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { Map, Draggable, Marker } from "pigeon-maps";
import { getAuthorization } from "../../../../axios/AxiosAut";
import { setAPIDetailsMapPoints } from "../../../../redux/slices/statistics/statisticSlice";
export default function Customermap() {
  const dispatch = useDispatch();
  const APIDetailsMapPoints = useSelector(
    (state) => state.statistics.APIDetailsMapPoints
  );

  const [MapPoints, setMapPoints] = useState([]);
  const getMapData = () => {
    getAuthorization()
      .get(`dashboard/customers/get_customers_map/`)
      .then((res) => {
        console.log("Map Points", res.data.points);
        setMapPoints(res.data.points);
        dispatch(setAPIDetailsMapPoints(res.data.points));
      })
      .catch((err) => {
        console.log("err", err);
      });
  };
  useEffect(() => {
    getMapData();
    console.log("MapPoints.....", MapPoints);
    console.log("APIDetailsMapPoints.....", APIDetailsMapPoints);
  }, []);

  const Points = [
    { lat: 37.0902, lng: 95.7129 },
    { lat: 21.04572, lng: 115.78116 },
    { lat: 21.04636, lng: 185.80536 },
  ];

  // const [center, setCenter] = useState([50.879, 4.6997]);

  // const [hue, setHue] = useState(0);
  // const color = `hsl(${hue % 360}deg 39% 70%)`;
  // const CIRCLE_RADIUS = 10;
  // const [polygon, setPolygon] = useState([
  //   [47.916671, 106.9098433],
  //   [47.920013, 106.9098014],
  //   [47.9205019, 106.915434],
  //   [47.916849, 106.9140603],
  // ]);
  return (
    <div>
      <div className="mt-8 sm:w-full md:w-full">
        <div class=" shadow-slate-400 shadow-md bg-white rounded-2xl flex-1">
          <div className="flex flex-wrap mr-4 mt-2 pt-2">
            <h3 className="text-lg font-bold mx-3"> Map of Customers</h3>
            <div className="float-right ml-auto mr-4 mt-1">
              <div className="float-right">
                <button className="rounded-full w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-blue-200 text-lg font-bold text-white outline-1 mx-2">
                  {" "}
                  M
                </button>
              </div>
              <div className="float-right">
                <button className="rounded-full text-blue-900 w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                  {" "}
                  Y
                </button>
              </div>
              <div className="relative text-gray-600 mr-3  border-1 rounded-3xl ml-10 float-right focus-within:text-gray-400">
                <span className="absolute text-slate-400 inset-y-0 left-0 flex items-center pl-2">
                  <button
                    type="submit"
                    className="p-1 focus:outline-none focus:shadow-outline"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      stroke-width="2"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M4 6h16M4 12h8m-8 6h16"
                      />
                    </svg>
                  </button>
                </span>
                <input
                  type="search"
                  className="py-2 text-sm outline-slate-100 outline focus:outline-slate-200 rounded-full pl-10 focus:outline-1 focus:bg-white focus:text-gray-900"
                  placeholder="Filter"
                  autocomplete="off"
                />
              </div>
              <div class=" flex border-b border-b-violet-800 mr-8 ">
                <input
                  class="w-full bg-transparent rounded-lg p-2"
                  type="text"
                  placeholder="Search"
                />
                <button class=" w-auto flex justify-end items-center text-blue p-2 hover:text-blue-light">
                  <svg
                    width="19"
                    height="19"
                    viewBox="0 0 19 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M18.1206 13.7553L13.5772 9.87719C14.4317 8.87406 14.9369 7.64031 14.9369 6.30781C14.9369 2.95469 11.7409 0.226562 7.81186 0.226562C3.88358 0.226562 0.6875 2.95469 0.6875 6.30781C0.6875 9.66156 3.88358 12.3891 7.81186 12.3891C9.30116 12.3891 10.6843 11.9972 11.8295 11.3278L16.397 15.2266L18.1206 13.7553ZM2.77721 6.30781C2.77721 3.93781 5.03607 2.00969 7.81259 2.00969C10.5891 2.00969 12.848 3.93781 12.848 6.30781C12.848 8.67781 10.5891 10.6059 7.81259 10.6059C5.03534 10.6059 2.77721 8.67781 2.77721 6.30781Z"
                      fill="#1F78B4"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>

          <div className="flex">
            <div className="flex-1 flex-wrap pl-4">
              <div className=" px-9 mt-7 ">
                <CircularProgressbar
                  value={86}
                  text={84}
                  circleRatio={0.75}
                  styles={buildStyles({
                    rotation: 1 / 2 + 1 / 8,
                    strokeLinecap: "butt",
                    // trailColor: "#26F32E",
                    textColor: "black",
                    pathColor: "#06E07F",
                    // trailColor: "gold"
                  })}
                />
              </div>
              <h1 className="text-lg text-center text-gray-500 font-bold pb-4 ">
                Total Customers
              </h1>
            </div>
            <div className="flex-2 flex-wrap pl-8">
              <div
                style={{ height: "40vh", overflow: "hidden" }}
                className="pb-8 pt-4 pr-8"
              >
                <Map defaultZoom={2} zoomOnMouseWheel={false} animate={true}>
                  {MapPoints?.map((p, i) => (
                    <Marker
                      key={i}
                      anchor={[parseFloat(p.latitude), parseFloat(p.longitude)]}
                      width={50}
                      color="#1F78B4"
                      // onMouseOver={handleover}
                      // payload={city}
                      // onClick={(payload) =>
                      //   alert(
                      //     `City: ${payload.payload.city} - Population: ${payload.payload.population}`
                      //   )
                      // }
                      // onClick={() => {
                      //   console.log("map here");
                      //   return <div title="djdj">ddddddd</div>;
                      // }}
                    />
                  ))}
                </Map>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}